// extracted by mini-css-extract-plugin
export var buttons = "styles-module--buttons--csvBF";
export var schemaLabel = "styles-module--schemaLabel--Q2RN1";